<template>
    <div class="academy-medal">
        <div>
            {{ count || 0 }}
        </div>
        <div :class="getTypeClass()">{{ getTranslation() }}</div>
    </div>
</template>

<script setup lang="ts">
    import { translate } from "../Common/translations";

    const props = defineProps<{
        count: number;
        place?: number;
    }>();

    function getTypeClass() {
        if (!props.place) {
            return "";
        }

        if (props.place === 1) {
            return "is-gold";
        }
        if (props.place === 2) {
            return "is-silver";
        }
        if (props.place === 3) {
            return "is-bronze";
        }
        if (props.place > 3) {
            return "is-extended";
        }

        return "";
    }

    function getTranslation() {
        if (!props.place) {
            return translate(`page.admin_academy_results.points`);
        }

        return translate(`page.admin_academy_results.place.${props.place}`);
    }
</script>

<style scoped></style>
